<template>
  <div>
    <!-- 搜索/新增 -->
    <div class="list-hd">
      <el-form :inline="true" v-model="searchValue" class="demo-form-inline">
        <el-form-item label="游戏:">
          <el-select
            v-model="searchValue.game_id"
            filterable
            clearable
            placeholder="请选择"
            @change="selectChannel"
            @clear="gameClear"
          >
            <el-option
              v-for="item in gamesList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="首次渠道:">
          <el-select
            v-model="searchValue.first_channel"
            filterable
            clearable
            multiple
            collapse-tags
            placeholder="请选择"
          >
            <el-option
              v-for="item in channelSelectList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区服:">
          <el-select
            v-model="searchValue.zone_id"
            filterable
            clearable
            multiple
            collapse-tags
            placeholder="请选择"
          >
            <el-option
              v-for="(item, i) in serverSelectList"
              :key="i"
              :label="item.name"
              :value="item.zone_id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="现渠道:">
          <el-select
            v-model="searchValue.channel_id"
            filterable
            clearable
            multiple
            collapse-tags
            placeholder="请选择"
          >
            <el-option
              v-for="item in channelSelectList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备号:">
          <el-input
            v-model="searchValue.devices"
            placeholder="设备号"
          ></el-input>
        </el-form-item>
        <el-form-item label="账号:">
          <el-input
            v-model="searchValue.username"
            placeholder="账号"
          ></el-input>
        </el-form-item>
        <el-form-item label="角色名:">
          <el-input
            v-model="searchValue.role_name"
            placeholder="角色名"
          ></el-input>
        </el-form-item>
        <el-form-item label="日期:">
          <el-date-picker
            v-model="value1"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchDeviceLoginLogList"
            >搜索</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="exportDeviceLoginLog()"
            >导出</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-table
      stripe
      ref="table"
      v-loading="loadingData"
      :data="tableData"
      :max-height="tableHeight"
      border
      style="width: 100%"
    >
      <el-table-column prop="register_date" label="注册日期" width="120">
      </el-table-column>
      <el-table-column prop="games.game_name" label="游戏" width="180">
      </el-table-column>
      <el-table-column prop="first_channel" label="首次渠道" width="180">
      </el-table-column>
      <el-table-column
        v-if="searchValue.zone_id != ''"
        prop="user_roles.zone_name"
        label="区服"
        width="180"
      ></el-table-column>
      <el-table-column prop="channel_ids" label="登录过渠道"> </el-table-column>
      <el-table-column prop="device_money" label="设备充值金额">
      </el-table-column>
      <el-table-column prop="devices" label="设备号"> </el-table-column>
      <el-table-column prop="channels.channel_name" label="现渠道" width="180">
      </el-table-column>
      <el-table-column prop="login_date" label="登录日期"> </el-table-column>
      <el-table-column prop="users.username" label="账号"> </el-table-column>
      <el-table-column prop="zone_name" label="区服"> </el-table-column>
      <el-table-column prop="role_name" label="角色"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            plain
            @click="deviceDetails(scope.row.devices)"
            >详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalRecords"
      >
      </el-pagination>
    </div>

    <!-- 详情弹出框 -->
    <el-dialog
      title="登录详情"
      :visible.sync="loginDetailDialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-table stripe :data="loginDetailData" border style="width: 100%">
        <el-table-column prop="game.game_name" label="游戏"> </el-table-column>
        <el-table-column prop="channels.channel_name" label="渠道">
        </el-table-column>
        <el-table-column prop="created_at" label="登录时间"> </el-table-column>
        <el-table-column prop="user.username" label="账号"> </el-table-column>
        <el-table-column prop="zone_name" label="区服"> </el-table-column>
        <el-table-column prop="name" label="角色名"> </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import fetch from "@/assets/js/axios.js";
import { urlSplicing } from "@/assets/js/public.js";
import moment from "moment";
export default {
  name: "deviceLoginLog",
  components: {},
  data() {
    return {
      loadingData: false,
      loginDetailDialogFormVisible: false,
      searchValue: {
        game_id: "",
        first_channel: "",
        channel_id: [],
        devices: "",
        zone_id: [],
        role_name: "",
        username: "",
        created_from: "",
        created_to: "",
      },
      value1: [],
      tableHeight: 0,
      historyValue: {},
      tableData: [],
      gamesList: [],
      loginDetailData: [],
      channelSelectList: [],
      channelSelectAllList: [],
      serverSelectList: [],
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
    };
  },
  computed: {
    ...mapState(["host"]),
  },
  created() {
    let dateStart = moment().subtract(0, "days").format("YYYY-MM-DD");
    let systemTime = moment(new Date()).format("YYYY-MM-DD");

    this.value1[0] = dateStart;
    this.value1[1] = systemTime;

    this.searchValue.created_from = this.value1[0];
    this.searchValue.created_to = this.value1[1];
    this.getchannelSelectList();
    this.getGameSelectList();
    this.getDeviceLoginLogList(true);
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["table"].doLayout();
    });
  },
  beforeMount(height) {
    var h = document.documentElement.clientHeight;
    this.tableHeight = h - 60; //减去页面上固定高度height
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.getDeviceLoginLogList(false);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getDeviceLoginLogList(false);
    },

    // 导出
    exportDeviceLoginLog() {
      let params = {
        ...this.historyValue, // 传对应的搜索的值
        export: 1,
        token: sessionStorage.getItem("access_token"),
      };

      urlSplicing(this.host + "admin/devices/device_login_log", params);
    },

    // 获取游戏选择列表数据
    getGameSelectList() {
      fetch({
        url: "/admin/games/select",
        method: "GET",
      }).then((res) => {
        if (res.data.status) {
          this.gamesList = res.data.data;
        }
      });
    },

    // 获取渠道选择列表数据
    getchannelSelectList() {
      fetch({
        url: "/admin/channels/select",
        method: "GET",
      }).then((res) => {
        if (res.data.status) {
          this.channelSelectAllList = res.data.data;
          this.channelSelectList = res.data.data;
        }
      });
    },
    // 获取区服选择列表数据
    getServerSelectList(vid) {
      fetch({
        url: "/admin/zones/select",
        method: "GET",
        params: {
          game_id: vid,
        },
      }).then((res) => {
        if (res.data.status) {
          this.serverSelectList = res.data.data;
        }
      });
    },

    // 根据所属游戏,显示对应的所属渠道
    selectChannel(vid) {
      this.searchValue.zone_id = [];
      this.searchValue.channel_id = [];
      this.channelSelectList = [];
      this.channelSelectAllList.forEach((item, i) => {
        if (item.game_id == vid) {
          this.channelSelectList.push(item);
        }
      });
      if (vid) {
        this.getServerSelectList(vid);
      }
    },
    // 清空游戏选项
    gameClear() {
      this.searchValue.zone_id = [];
      this.searchValue.channel_id = [];
      this.serverSelectList = [];
      this.getchannelSelectList();
    },
    // 实现设备渠道登录日志数据的搜索
    searchDeviceLoginLogList() {
      this.searchValue.created_from = this.value1 && this.value1.length === 2 ? this.value1[0] : '';
      this.searchValue.created_to = this.value1 && this.value1.length === 2 ? this.value1[1] : '';
      this.currentPage = 1;
      this.getDeviceLoginLogList(true);
    },

    // 详情
    deviceDetails(devices) {
      this.loginDetailDialogFormVisible = true;
      fetch({
        url: "admin/devices/device_details",
        method: "GET",
        params: {
          devices: devices,
        },
      }).then((res) => {
        this.loginDetailData = res.data.data;
      });
    },

    //获取 设备渠道登录日志 列表
    getDeviceLoginLogList(reload = false) {
      let searchValue = {};
      if (reload) {
        this.historyValue = JSON.parse(JSON.stringify(this.searchValue));
        searchValue = this.searchValue;
      } else {
        searchValue = this.historyValue;
      }
      this.loadingData = true;
      let channel_id = this.searchValue.channel_id.toString();
      let zone_id = this.searchValue.zone_id.toString();
      fetch({
        url: "admin/devices/device_login_log",
        method: "GET",
        params: {
          ...searchValue,
          channel_id: channel_id,
          zone_id: zone_id,
          page: this.currentPage,
          per_page: this.pageSize,
        },
      })
        .then((res) => {
          if (res.data.status) {
            this.tableData = res.data.data.data;
            this.totalRecords = res.data.data.total;
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
  },
};
</script>
<style lang="less">
.pagination {
  text-align: right;
  margin-top: 20px;
  padding-bottom: 20px;
}
.list-hd {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  .el-input-group {
    width: 370px;
  }
}
</style>
